import InexCard from "../../InexCard";
import { Box, Typography } from "@mui/material";
import RainbowDivider from "../../misc/RainbowDivider";
import React from "react";

const EventPublicCard = ({ event }) => {
  return (
    <InexCard
      sx={{
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        display: "flex",
        flexDirection: "column",
        minWidth: "100%",
        height: "100%",
        minHeight: "100%",
        userSelect: "none",
        flexGrow: 1,
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
          aspectRatio: 400 / 340,
          height: 340,
          minHeight: 340,
          width: "100%",
          "& > img": {
            objectFit: "cover",
            width: "100%",
            cursor: "pointer",
          },
        }}
        onClick={() => {
          window.open(
            `https://boutique.inexplore.com/evenement/${event.slug}`,
            "_blank",
          );
        }}
      >
        <img
          src={`https://medias.inrees.com/img/agenda/affiche_${event?.id}.jpg`}
          alt={"eventImage"}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          padding: "15px",
          display: "flex",
          alignItems: "flex-start",
          height: "100%",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            justifyContent: "space-between",
            flexGrow: 1,
            mt: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Yesevaone SemiBold !important",
                fontSize: "24px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                color: "black",
                verticalAlign: "top",
                fontWeight: "bold",
                maxHeight: "100%",
              }}
            >
              {event.titre}
            </Typography>
          </Box>
        </Box>

      </Box>
      <RainbowDivider
        sx={{
          marginTop: "auto",
          zIndex: 1,
          height: "3px",
        }}
      />
    </InexCard>
  );
};

export default EventPublicCard;
